import GlassCard from "Developers/JuanBecchio/Components/GlassCard";

const MusicaSoundtrack = (): JSX.Element => {
  return (
    <div>
      <h5 className='mt-4 text-center subtitle-inner-section'>Soundtracks</h5>
      <div className='devprofile-extra-inner'>
        <GlassCard tooltip='Capitain America - The Winter Soldier'>
          <iframe
            className='compact'
            title='Captain'
            src='https://open.spotify.com/embed/track/3kOrJfOm3anNJospQ6l21S'
            allow='encrypted-media'
          />
        </GlassCard>
        <GlassCard tooltip='DOOM'>
          <iframe
            className='compact'
            title='DOOM'
            src='https://open.spotify.com/embed/track/5soMJpcVhSrGrB4prvPL6P'
            allow='encrypted-media'
          />
        </GlassCard>
        <GlassCard tooltip='Metal Gear Rising'>
          <iframe
            className='compact'
            title='MetalGear'
            src='https://open.spotify.com/embed/track/29eKlSdk4dmwBgqtwASiFW'
            allow='encrypted-media'
          />
        </GlassCard>
      </div>
    </div>
  );
};

export default MusicaSoundtrack;
